const getIsSearch = state => state.isSearch;
const getTextSearch = state => state.textSearch;
const getIsSearchAdvanced = state => state.isSearchAdvanced;

export default {
  getIsSearch,
  getTextSearch,
  getIsSearchAdvanced,
};



// WEBPACK FOOTER //
// ./src/store/modules/search/getters.js